import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useLocation } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import PageHeader from '../../components/PageHeader'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import contractPagesRoleManagement from '../../staticRoleManagement/contractRoleManagement'
import ContractsList from '../ContractsList'
import TemplatesList from '../TemplatesList'
import useStyles from './styles/index.styles'

export default function ContractTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { pathname } = useLocation()

  const page = pathname.slice(pathname.lastIndexOf('/') + 1)

  const tabsList = [
    {
      value: 'templates',
      className: classes.tab,
      label: getTranslate('Templates'),
      component: LocalizedLink,
      to: '/contracts/templates'
    },
    {
      value: 'list',
      className: classes.tab,
      label: getTranslate('Contracts'),
      component: LocalizedLink,
      to: '/contracts/list'
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = contractPagesRoleManagement.find(
    (item) => item.route === '/contracts/(list|templates)'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <PageHeader title={getTranslate('Contracts')} />
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((tabItem) => (
            <Tab
              key={tabItem.value}
              value={tabItem.value}
              className={tabItem.className}
              label={tabItem.label}
              to={tabItem.to}
              component={LocalizedLink}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="templates"
        dir={theme.direction}
        className={classes.tabPanel}>
        <TemplatesList />
      </TabPanel>
      <TabPanel
        value={page}
        index="list"
        dir={theme.direction}
        className={classes.tabPanel}>
        <ContractsList />
      </TabPanel>
    </div>
  )
}
